import { createSlice } from '@reduxjs/toolkit';
import { createComplaint, updateComplaintTypeActive } from './actions';

const initialState = {
  data: null,
  isLoading: false,
  error: null,
  hasLoaded: false,
  isActive: true,
  activeComplaintTypeId: null,
  isUpdatingActive: false,
  activeError: null,
};

const errorMessage = (action) =>
  action.payload?.message ?? action.error?.message ?? 'Failed to create complaint';

const activeErrorMessage = (action) =>
  action.payload?.message ?? action.error?.message ?? 'Failed to update complaint type';

const createComplaintSlice = createSlice({
  name: 'createComplaint',
  initialState,
  reducers: {
    // Unused: nothing dispatches these helpers.
    // clearCreateComplaintError: (state) => {
    //   state.error = null;
    //   state.activeError = null;
    // },
    // resetCreateComplaintState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(createComplaint.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.hasLoaded = false;
      })
      .addCase(createComplaint.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasLoaded = true;
        state.data = action.payload?.data ?? action.payload;
      })
      .addCase(createComplaint.rejected, (state, action) => {
        if (action.meta.aborted) return;
        state.isLoading = false;
        state.hasLoaded = true;
        state.error = errorMessage(action);
      })
      .addCase(updateComplaintTypeActive.pending, (state) => {
        state.isUpdatingActive = true;
        state.activeError = null;
      })
      .addCase(updateComplaintTypeActive.fulfilled, (state, action) => {
        state.isUpdatingActive = false;
        const updated = action.payload?.data ?? action.payload;
        state.activeComplaintTypeId = updated?.id ?? action.meta?.arg?.id ?? null;
        state.isActive = Boolean(
          updated?.isActive ?? updated?.active ?? action.meta?.arg?.isActive,
        );
      })
      .addCase(updateComplaintTypeActive.rejected, (state, action) => {
        if (action.meta.aborted) return;
        state.isUpdatingActive = false;
        state.activeError = activeErrorMessage(action);
      });
  },
});

// export const { clearCreateComplaintError, resetCreateComplaintState } =
//   createComplaintSlice.actions;
export default createComplaintSlice.reducer;
